import { Carousel, Slide } from 'vue-carousel'

export default {
  data() {
    return {
      courses: [],
      categories: [],
      levels: [],
      filters: [],
      filteredSubjects: [],
      filteredLevels: [],
      filteredSubjectsNames: [],
      filtersArray: [],
      selectedSessionStarts: [],
      session_start_dates: [],
      filterApplied: false,
      searchQuery: '',
      paginator: null,
      selectedFilter: {
        id: null,
        name: null
      },
      mobileBreakPoint: 768,

      showingSearchResults: false,

      acceptedURLParams: [
        'q', 'filters', 'filters[]', 'subjects', 'subjects[]', 'levels', 'levels[]', 'partners', 'partners[]'
      ],

      allFilters: [
        { id: 'current', name: 'Current' },
        { id: 'soon', name: 'Starting Soon' },
        { id: 'upcoming', name: 'Upcoming' }
      ],

      allSessionsStartDate: [],

      show_share_modal: false,
      share_modal_params: null,
      show_cohort_locked_modal: false,
      cohort_locked_modal_params: null,
      show_locked_modal: false,
      locked_modal_params: null,
      show_unlock_modal: false,
      unlock_modal_params: null,
      show_onboarding_modal: false,

      carousel: {
        course: { page_count: 0, first_page: false, last_page: false },
        microCourse: { page_count: 0, first_page: false, last_page: false },
        program: { page_count: 0, first_page: false, last_page: false }
      }
    };
  },

  components: {
    Carousel,
    Slide
  },

  watch: {
    filteredLevels() { this.filterChanged() },
    filteredSubjects() { this.filterChanged() },
    filters() { this.filterChanged() },
    searchQuery() { this.filterChanged() },
    selectedSessionStarts() { this.filterChanged() },
  },

  methods: {
    initializeData(data, ended_courses_count){
      this.courses = data.courses
      this.micro_courses = data.micro_courses
      this.programs = data.programs
      this.standard_courses = data.standard_courses
      this.default_course = data.default_course
      this.paginator = data.paginator
      this.categories = data.categories
      this.filteredCategories = data.filteredCategories || []
      this.filtersArray = data.filtersArray || []
      this.levels = data.levels
      this.allSessionsStartDate = data.all_sessions_start_date
      this.session_start_dates = data.session_start_dates || []

      if(ended_courses_count) {
        this. allFilters = [
          { id: 'current', name: 'Current' },
          { id: 'soon', name: 'Starting Soon' },
          { id: 'upcoming', name: 'Upcoming' },
          { id: 'ended', name: 'Past Courses' }
        ];
      }
    },

    removeSubject(id) {
      this.filteredSubjects.splice(this.filteredSubjects.indexOf(id.toString()), 1)
      this.updateUrl();
    },

    removeLevel(level) {
      this.filteredLevels.splice(this.filteredLevels.indexOf(level), 1)
      this.updateUrl();
    },

    removeFilter(filter) {
      this.filters.splice(this.filters.indexOf(filter.id), 1)
      this.updateUrl();
    },

    removeSessionStartDate(sessionStartDate) {
      this.selectedSessionStarts.splice(this.selectedSessionStarts.indexOf(sessionStartDate), 1)
      this.updateUrl();
    },

    toggleMobileOptions() {
      $('#mobile_course_filter_options_modal').modal('toggle')
    },

    clearFilters() {
      this.filteredSubjects = []
      this.filteredLevels = []
      this.filters = []
      this.selectedSessionStarts = []
      this.filterChanged()
    },

    filterChanged() {
      this.courseListing()
      this.updateUrl();
    },

    clearSearch() {
      this.searchQuery = ''
      this.courseListing().then(() => {
        this.showingSearchResults = false
        this.updateUrl();
      });
    },

    buildQuery(url) {
      const query = {};

      if (typeof url !== 'undefined')
        query.page = Kadenze.Util.getURLParams(url.replace('/courses', '')).page;

      if (!_.isEmpty(this.searchQuery))
        query.q = this.searchQuery;

      this.filterApplied = false;

      query.subjects = this.filteredSubjects || [];
      query.levels = this.filteredLevels || [];
      query.filters = this.filters || [];
      query.session_start_dates = this.selectedSessionStarts || [];

      return query;
    },

    updateUrlParams(url) {
      const historyApi = typeof history.replaceState !== 'undefined';

      if (historyApi) {
        const state = Object.assign({}, history.state, { url: url });
        history.replaceState(state, 'Course Catalog', url);
      }
    },

    courseListing(url) {
      Kadenze.UIUtil.showLoadingIndicator(this.$el, null, 'fixed')

      const req = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.courses_path(this.buildQuery(url)),
        beforeSend: () => this.updateUrlParams(this.url)
      });

      req.done(courses => {
        if (courses.query_params) {
          if (courses.query_params.subjects)
            courses.filteredCategories = this.getFilteredObjects(
              this.categories,
              courses.query_params.subjects
            )

          if (Kadenze.isKannu) {
            if (courses.query_params.filters) {
              courses.filtersArray = this.getFilteredObjects(
                this.allFilters,
                courses.query_params.filters
              )

              this.filterApplied = true
            }

            if (courses.query_params.session_start_dates) {
              this.filterApplied = true
            }
          }

          if (Kadenze.isKadenze && courses.query_params.levels)
            this.filterApplied = true
        }

        $('.select-box').removeClass('hide')

        this.initializeBindData(courses, courses.counts.past_count)

        this.showingSearchResults = !_.isEmpty(this.searchQuery)

        Kadenze.UIUtil.initLazyImageLoading()

        if ($('#courses').find('.course-card__link').length)
          $('#courses').find('.course-card__link')[0].focus()
      })

      req.fail(data => console.warn('error retrieving course data', data))

      req.always(data => {
        Kadenze.UIUtil.hideLoadingIndicator(this.$el);
        Kadenze.PaginationBinding.applyBindingsWithTextInput(this.courseListing)
      })

      return req
    },

    updateCarouselNav(type = 'course') {
      this.carousel[type].page_count = this.$refs[`${type}Carousel`].pageCount

      this.carousel[type].first_page = this.$refs[`${type}Carousel`].currentPage === 0

      this.carousel[type].last_page = this.$refs[`${type}Carousel`].currentPage === (
        this.$refs[`${type}Carousel`].pageCount - 1
      );
    },

    navCarousel(type = 'course', action = 'next') {
      if (action === 'prev')
        this.$refs[`${type}Carousel`].goToPage(
          this.$refs[`${type}Carousel`].getPreviousPage()
        )
      else
        this.$refs[`${type}Carousel`].goToPage(
          this.$refs[`${type}Carousel`].getNextPage()
        )

      this.updateCarouselNav(type)
    },

    showShareModal(params) {
      this.share_modal_params = params
      this.show_share_modal = true
    },

    showCohortLockedModal(params) {
      this.cohort_locked_modal_params = params
      this.show_cohort_locked_modal = true
    },

    showLockedModal(params) {
      this.locked_modal_params = params
      this.show_locked_modal = true
    },

    showUnlockModal(params) {
      this.unlock_modal_params = params
      this.show_unlock_modal = true
    },

    getObjectById(array, id) {
      return array.find(obj => obj.id == id)
    },

    getFilteredObjects(array, ids = []) {
      return ids.map(id => this.getObjectById(array, id))
    },

    appliedfilterDataNotPresent() {
      return (
        !this.courses.length && (
          !this.programs.length || (
            this.filtersCount() && !this.filteredCategories.length
          )
        )
      )
    },

    filtersCount() {
      return (
        this.filteredCategories.length +
          (this.filteredLevels || []).length +
            (this.filters || []).length +
            (this.session_start_dates || []).length
      )
    },

    enableSearch() {
      $('.select-box').addClass('hide')
    },

    mobileView() {
      const windowWidth = screen.width
      return (windowWidth < this.mobileBreakPoint)
    },

    initializeBindData(data, ended_courses_count) {
      this.initializeData(data, ended_courses_count)
    },

    initializeCarousel(data) {
      if (Kadenze.isKadenze) {
        if (data.standard_courses.length)
          this.updateCarouselNav()

        if (data.micro_courses.length)
          this.updateCarouselNav('microCourse')

        if (data.programs.length)
          this.updateCarouselNav('program')
      }
    },

    // Method to parse URL parameters
    parseUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);

      // Extract filter criteria from URL params
      const title = urlParams.get('title');
      const subjects = urlParams.getAll('subject');
      const skillLevels = urlParams.getAll('skilllevel');
      const filters = urlParams.getAll('filters');

      // Apply filters based on extracted criteria
      if (title) {
        this.searchQuery = title; // Set search query
      }
      if (subjects.length) {
        this.filteredSubjects = subjects; // Set subject filters
      }
      if (skillLevels.length) {
        this.filteredLevels = skillLevels; // Set skill level filters
      }
      if (filters.length) {
        this.filters = filters; // Set skill level filters
      }

      // Apply filters to course listing
      this.courseListing();
    },

    // Method to update URL with filter criteria
    updateUrl() {
      const urlParams = new URLSearchParams();

      // Add filter criteria to URL params
      if (this.searchQuery) {
        urlParams.set('title', this.searchQuery);
      }
      if (this.filteredSubjects.length > 0) {
        this.filteredSubjects.forEach(subject => {
          urlParams.append('subject', subject);
        });
      }
      if (this.filteredLevels.length > 0) {
        this.filteredLevels.forEach(level => {
          urlParams.append('skilllevel', level);
        });
      }
      if (this.filters.length > 0) {
        this.filters.forEach(filters => {
          urlParams.append('filters', filters);
        });
      }

      // Update URL with new params
      const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      history.pushState({}, '', newUrl);
    }
  },

  mounted() {
    // Parse URL parameters on component mount
    this.parseUrlParams();
    this.initializeCarousel(this);
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.courseListing);
  }
};
